import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const SupplierDetailPage = lazy(() => import("@/features/supplier-master/pages/supplier-detail"));

export const Route = createFileRoute("/(app)/dashboard/suppliers/$supplierId")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading supplier...</div>}>
      <SupplierDetailPage />
    </Suspense>
  ),
});
